const getters = {
  onlineUsers: (state) => {
    return state.status
  }
}

export default {
  ...getters
}
